import { TrashDuotoneLine } from '@profgeosoft-ui/icons';
import { Modal, Button } from '@profgeosoft-ui/react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import styles from './confirm-reset-settings-modal.module.scss';

type Props = {
  isModalOpened: boolean;
  onApply: VoidFunction;
  onCancel: VoidFunction;
};

export const ConfirmResetSettingsModal = wrap<Props>(function ConfirmResetSettingsModal({
  isModalOpened,
  onCancel,
  onApply,
}) {
  const { t } = useTranslation();

  return (
    <Modal open={isModalOpened} className={styles.modal} onClickOutside={null}>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{t('modals:ResetSettings.title')}</h2>
        <p className={styles.descriptionParagraph}>{t('modals:ResetSettings.description')}</p>

        <div className={styles.buttonsWrapper}>
          <Button variant="flat" className={styles.button} iconPosition="before" onClick={onCancel}>
            {t('common:cancel')}
          </Button>

          <Button
            variant="danger"
            icon={<TrashDuotoneLine />}
            className={styles.button}
            iconPosition="before"
            onClick={onApply}
          >
            {t('common:reset')}
          </Button>
        </div>
      </div>
    </Modal>
  );
});
